export enum IGoogleSitesAreasTableEnum {
  Area = 'area',
  Status = 'status',
  LastCopiedDate = 'lastCopiedDate',
  Copy = 'copy',
  Name = 'integrationName',
}
